// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","new":"new_Nhvhz","overlayImage":"overlayImage_T31ks","deposit":"deposit_EBXYu"};